import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { MoedaPipe } from './moeda.pipe';
import { MoedaCodigoPipe } from './moeda-codigo.pipe';
import { MoedaSimboloPipe } from './moeda-simbolo.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        MoedaPipe,
        MoedaCodigoPipe,
        MoedaSimboloPipe
    ],
    exports: [
        MoedaPipe,
        MoedaCodigoPipe,
        MoedaSimboloPipe
    ],
    providers: [
        MoedaPipe,
        MoedaCodigoPipe,
        MoedaSimboloPipe
    ]
})
export class MoedaPipeModule { }
